export default "__VITE_ASSET__gYh51QGx__"